export default __webpack_public_path__ + "static/media/ido-erlichman.ff66bdc3.png";